import type { Movie } from '@/types';

export const movies: Movie[] = [
  {
    id: '1',
    title: '寄生虫',
    titleEn: 'Parasite',
    year: 2019,
    director: '奉俊昊',
    cast: ['宋康昊', '李善均', '曹如晶', '崔宇植', '朴素丹'],
    genres: ['剧情', '黑色幽默', '悬疑'],
    duration: 132,
    rating: 9.2,
    cover: 'https://readdy.ai/api/search-image?query=moody%20cinematic%20Korean%20drama%20film%20poster%20style%2C%20basement%20stairs%20metaphor%2C%20olive%20and%20amber%20tones%2C%20minimalist%20composition%2C%20no%20text%2C%20grainy%20film%20texture&width=600&height=900&seq=kfilm-poster-01&orientation=portrait',
    summary: '一个底层家庭渗透进富人家庭，阶层寓言在黑色幽默中层层剥开。',
    synopsis: '居住在逼仄半地下室的金家四口，靠着一次偶然的机会，让儿子进入富豪朴社长家中担任家教。此后，一家人以巧妙的方式逐一渗透进这栋设计精良的豪宅，各自攀附上不同的岗位。然而豪宅地板之下埋藏的秘密，最终在一个暴雨之夜被彻底揭开。奉俊昊用垂直空间作为阶层隐喻，把类型片的张力与作者电影的表达熔于一炉。',
    releaseDate: '2019-05-30',
    region: '韩国',
    tags: ['阶层寓言', '奉俊昊', '影史经典'],
  },
  {
    id: '2',
    title: '老男孩',
    titleEn: 'Oldboy',
    year: 2003,
    director: '朴赞郁',
    cast: ['崔岷植', '刘智泰', '姜惠贞'],
    genres: ['剧情', '惊悚', '复仇'],
    duration: 120,
    rating: 8.9,
    cover: 'https://readdy.ai/api/search-image?query=dark%20cinematic%20Korean%20revenge%20thriller%20poster%2C%20narrow%20hotel%20corridor%2C%20cold%20teal%20and%20amber%20light%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-02&orientation=portrait',
    summary: '被莫名囚禁十五年的男人，在复仇之路上走向一个令人窒息的真相。',
    synopsis: '吴大修在女儿生日那天被人绑架，随后在一间密闭房间里被囚禁了整整十五年，仅靠一台电视知晓外界的变迁。重获自由后，他得到五天时间找出囚禁自己的凶手。复仇的齿轮一旦启动，便再也无法停下，而真相的重量远远超出他的想象。朴赞郁以暴烈而优雅的视听语言，探讨了仇恨、伦理与救赎的边界。',
    releaseDate: '2003-11-21',
    region: '韩国',
    tags: ['复仇三部曲', '朴赞郁', '影史经典'],
  },
  {
    id: '3',
    title: '小姐',
    titleEn: 'The Handmaiden',
    year: 2016,
    director: '朴赞郁',
    cast: ['金敏喜', '金泰梨', '河正宇', '赵震雄'],
    genres: ['剧情', '悬疑', '爱情'],
    duration: 145,
    rating: 8.7,
    cover: 'https://readdy.ai/api/search-image?query=elegant%20period%20Korean%20film%20poster%2C%20Victorian%20mansion%20interior%2C%20emerald%20and%20gold%20tones%2C%20refined%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-03&orientation=portrait',
    summary: '一场精心设计的骗局，在两个女人的目光交汇处彻底转向。',
    synopsis: '在日本殖民时期的朝鲜，骗术高手伯爵计划将孤女秀子小姐的财产据为己有，他找来扒手少女淑熙潜入宅邸充当侍女，里应外合。然而在朝夕相处中，计划的两端悄然生出真实的情感。朴赞郁将三段式叙事拆解重组，在悬疑、情欲与权力之间编织出一场关于凝视与解放的华丽游戏。',
    releaseDate: '2016-06-01',
    region: '韩国',
    tags: ['女性凝视', '朴赞郁', '文学改编'],
  },
  {
    id: '4',
    title: '燃烧',
    titleEn: 'Burning',
    year: 2018,
    director: '李沧东',
    cast: ['刘亚仁', '史蒂文·元', '全钟瑞'],
    genres: ['剧情', '悬疑', '文艺'],
    duration: 148,
    rating: 8.5,
    cover: 'https://readdy.ai/api/search-image?query=melancholic%20cinematic%20Korean%20literary%20drama%20poster%2C%20sunset%20field%20with%20greenhouse%20silhouette%2C%20warm%20dusk%20amber%20and%20dusty%20olive%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-04&orientation=portrait',
    summary: '青年钟秀在爱情与猜疑之间越陷越深，一场无形的燃烧悄然开始。',
    synopsis: '梦想成为作家的青年钟秀偶然遇见儿时邻居惠美，两人短暂靠近后，惠美从非洲旅行归来，带回一个神秘富有的男人本。本有着难以解释的爱好，而惠美也在某一天凭空消失。钟秀在寻找惠美的过程中，被一种无法证实的猜想彻底吞噬。李沧东以村上春树的短篇为底本，拍出了一部关于阶层、愤怒与虚无的当代寓言。',
    releaseDate: '2018-05-17',
    region: '韩国',
    tags: ['文学改编', '李沧东', '当代寓言'],
  },
  {
    id: '5',
    title: '诗',
    titleEn: 'Poetry',
    year: 2010,
    director: '李沧东',
    cast: ['尹静姬', '李大为', '金熙罗'],
    genres: ['剧情', '文艺'],
    duration: 139,
    rating: 8.4,
    cover: 'https://readdy.ai/api/search-image?query=quiet%20poetic%20Korean%20film%20poster%2C%20elderly%20woman%20by%20a%20river%20with%20flowers%2C%20soft%20ivory%20and%20muted%20green%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-05&orientation=portrait',
    summary: '一位患病的老人一边照顾孙子，一边在苦难中寻找写诗的灵感。',
    synopsis: '年过六旬的美子独自抚养正值青春期的孙子，同时靠做钟点工补贴家用。她参加社区的诗歌班，想在暮年写出一首真正的诗。可生活却把一桩沉重的家庭丑闻推到她面前，美子在照顾旁人与直面现实之间反复挣扎。影片以极克制的笔触，让美在疼痛中缓慢地生根。',
    releaseDate: '2010-05-13',
    region: '韩国',
    tags: ['女性主角', '李沧东', '诗意现实'],
  },
  {
    id: '6',
    title: '杀人回忆',
    titleEn: 'Memories of Murder',
    year: 2003,
    director: '奉俊昊',
    cast: ['宋康昊', '金相庆', '朴海日'],
    genres: ['剧情', '犯罪', '悬疑'],
    duration: 132,
    rating: 9.0,
    cover: 'https://readdy.ai/api/search-image?query=retro%20Korean%20crime%20drama%20poster%2C%20empty%20rural%20rice%20field%20under%20overcast%20sky%2C%20desaturated%20olive%20and%20grey%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-06&orientation=portrait',
    summary: '一桩始终未破的连环案件，改变了两个警察的一生。',
    synopsis: '1986 年，京畿道华城一带接连被发现女性遇害。地方警察朴斗满习惯凭直觉办案，而首尔派来的徐泰润则崇尚证据与逻辑。两个性格迥异的警探在一次次调查与失败中，逐渐被无解的悬案消耗殆尽。奉俊昊用类型片的外壳，记录下那个时代的无力与荒诞。',
    releaseDate: '2003-05-02',
    region: '韩国',
    tags: ['真实改编', '奉俊昊', '影史经典'],
  },
  {
    id: '7',
    title: '亲切的金子',
    titleEn: 'Sympathy for Lady Vengeance',
    year: 2005,
    director: '朴赞郁',
    cast: ['李英爱', '崔岷植', '金时厚'],
    genres: ['剧情', '惊悚', '复仇'],
    duration: 115,
    rating: 8.2,
    cover: 'https://readdy.ai/api/search-image?query=stylized%20Korean%20revenge%20drama%20poster%2C%20woman%20in%20red%20elegant%20coat%2C%20cool%20blue%20and%20crimson%20accent%2C%20artful%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-07&orientation=portrait',
    summary: '在狱中积攒十三年的善意，只为出狱后完成一场精致的复仇。',
    synopsis: '美貌的金子因被控杀害男童而入狱，十三年的服刑岁月里她以无尽的善意赢得狱友们的信任与爱戴，被称为「亲切的金子」。出狱后，这些善意化作一张复仇的网络，她逐一找到当年的证人，只为揪出真正的凶手。影片以华美的形式感讲述一个关于罪与罚、宽恕与审判的故事。',
    releaseDate: '2005-07-29',
    region: '韩国',
    tags: ['复仇三部曲', '朴赞郁', '形式美学'],
  },
  {
    id: '8',
    title: '密阳',
    titleEn: 'Secret Sunshine',
    year: 2007,
    director: '李沧东',
    cast: ['全度妍', '宋康昊'],
    genres: ['剧情', '文艺'],
    duration: 142,
    rating: 8.3,
    cover: 'https://readdy.ai/api/search-image?query=intimate%20Korean%20melodrama%20poster%2C%20small%20town%20street%20under%20grey%20daylight%2C%20muted%20beige%20and%20slate%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-08&orientation=portrait',
    summary: '一个失去至亲的女人，在信仰与宽恕之间走向精神的深渊。',
    synopsis: '申爱带着儿子搬到亡夫的故乡密阳，想在这里重新开始生活。一场突如其来的灾难击碎了她的平静，她在宗教中寻求慰藉，却发现「原谅」这道命题远比想象中残酷。李沧东用大量留白与克制的时间，贴身跟随一个女人从崩溃到质问命运的全过程。',
    releaseDate: '2007-05-17',
    region: '韩国',
    tags: ['女性主角', '李沧东', '信仰追问'],
  },
  {
    id: '9',
    title: '春夏秋冬又一春',
    titleEn: 'Spring, Summer, Fall, Winter... and Spring',
    year: 2003,
    director: '金基德',
    cast: ['吴永洙', '金基德', '韩如云'],
    genres: ['剧情', '文艺', '禅意'],
    duration: 103,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=serene%20zen%20Korean%20film%20poster%2C%20floating%20temple%20on%20misty%20lake%2C%20soft%20green%20and%20ivory%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-09&orientation=portrait',
    summary: '一座水上佛寺里，四季轮回映照着一段生命的因果。',
    synopsis: '在群山环抱的一片湖面上，一座小小的佛寺随波漂浮。老僧与年幼的小僧在此清修，四季更迭之间，小僧从天真到欲望萌动，再到出走、归来、赎罪。影片以四个章节对应人生的四个季节，用极简的场景与悠长的镜头，讲述轮回、欲望与觉悟。',
    releaseDate: '2003-09-19',
    region: '韩国',
    tags: ['禅意美学', '金基德', '结构叙事'],
  },
  {
    id: '10',
    title: '空房间',
    titleEn: '3-Iron',
    year: 2004,
    director: '金基德',
    cast: ['在熙', '李丞涓'],
    genres: ['剧情', '爱情', '文艺'],
    duration: 88,
    rating: 7.9,
    cover: 'https://readdy.ai/api/search-image?query=quiet%20art%20house%20Korean%20film%20poster%2C%20empty%20sunlit%20apartment%20room%20with%20mirror%2C%20warm%20amber%20and%20cream%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-10&orientation=portrait',
    summary: '一个骑着摩托逐户「借住」空房的青年，遇见了一位沉默的女人。',
    synopsis: '泰锡每天把传单塞进居民的门缝，然后趁主人外出时住进空荡的房子，替人整理房间、修理小物件。一次闯入中，他遇见了被丈夫暴力相向的善华，两人在无声的默契里开始一段奇异的同行。全片几乎无对白，金基德用影像本身完成了关于爱与占有的寓言。',
    releaseDate: '2004-10-15',
    region: '韩国',
    tags: ['无声叙事', '金基德', '极简'],
  },
  {
    id: '11',
    title: '醉画仙',
    titleEn: 'Chihwaseon',
    year: 2002,
    director: '林权泽',
    cast: ['崔岷植', '安圣基', '刘好贞'],
    genres: ['剧情', '传记', '历史'],
    duration: 120,
    rating: 7.8,
    cover: 'https://readdy.ai/api/search-image?query=traditional%20Korean%20historical%20film%20poster%2C%20ink%20painting%20brushstroke%20abstract%2C%20sepia%20and%20charcoal%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-11&orientation=portrait',
    summary: '朝鲜时代天才画家张承业颠沛而狂放的一生。',
    synopsis: '影片取材自朝鲜王朝画家张承业的生平。出身贫寒的他，凭借惊人的天赋在画坛崭露头角，却终生挣脱不了身世的枷锁与时代的纷乱。他纵情于酒色与创作之间，只为在宣纸之上留住心中那团不灭的火。林权泽用沉静的镜头，为艺术家的孤独写下注脚。',
    releaseDate: '2002-05-10',
    region: '韩国',
    tags: ['传记', '林权泽', '传统美学'],
  },
  {
    id: '12',
    title: '西便制',
    titleEn: 'Sopyonje',
    year: 1993,
    director: '林权泽',
    cast: ['吴侦孩', '金圭哲', '金明坤'],
    genres: ['剧情', '音乐', '历史'],
    duration: 112,
    rating: 8.1,
    cover: 'https://readdy.ai/api/search-image?query=traditional%20Korean%20pansori%20music%20film%20poster%2C%20wandering%20performer%20on%20a%20dusty%20road%2C%20warm%20ochre%20and%20brown%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-12&orientation=portrait',
    summary: '一段颠沛流离的潘索里传承，藏着一个民族的声音。',
    synopsis: '流浪艺人俞凤带着收养的两个孩子，一路以潘索里歌艺糊口。为了让女儿松华练就真正的歌喉，他狠下心用粗暴的方式对待她，甚至弄瞎了她的双眼。多年后，离开的弟弟东浩重返故土，只为寻找姐姐的歌声。影片让传统说唱在银幕上获得了动人的生命。',
    releaseDate: '1993-04-10',
    region: '韩国',
    tags: ['传统艺术', '林权泽', '影史经典'],
  },
  {
    id: '13',
    title: '蔷花，红莲',
    titleEn: 'A Tale of Two Sisters',
    year: 2003,
    director: '金知云',
    cast: ['林秀晶', '文瑾莹', '廉晶雅'],
    genres: ['剧情', '恐怖', '悬疑'],
    duration: 114,
    rating: 7.7,
    cover: 'https://readdy.ai/api/search-image?query=atmospheric%20Korean%20psychological%20horror%20poster%2C%20old%20wooden%20mansion%20hallway%20with%20dim%20light%2C%20muted%20green%20and%20cream%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-13&orientation=portrait',
    summary: '两姐妹回到乡间别墅，家中弥漫着说不清的压抑与秘密。',
    synopsis: '经历一场变故后，秀薇与秀莲两姐妹回到父亲的乡间别墅，与继母同住。屋内每一处角落似乎都藏着未说的话，继母的敌意与父亲的心不在焉让姐妹俩愈发不安。随着记忆被一层层揭开，真相以令人心碎的方式显现。金知云将心理恐怖与家庭创伤缝合得密不透风。',
    releaseDate: '2003-06-13',
    region: '韩国',
    tags: ['心理恐怖', '金知云', '家庭创伤'],
  },
  {
    id: '14',
    title: '追击者',
    titleEn: 'The Chaser',
    year: 2008,
    director: '罗泓轸',
    cast: ['金伦奭', '河正宇', '徐令姬'],
    genres: ['剧情', '犯罪', '惊悚'],
    duration: 125,
    rating: 8.1,
    cover: 'https://readdy.ai/api/search-image?query=gritty%20Korean%20crime%20thriller%20poster%2C%20rain%20soaked%20city%20alley%20at%20night%2C%20cold%20blue%20and%20amber%20streets%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-14&orientation=portrait',
    summary: '一个落魄的皮条客追查失踪女孩，却发现凶手的轮廓近在咫尺。',
    synopsis: '前警探正浩如今靠经营应召女郎勉强糊口，手下女孩频频失踪让他损失惨重。为了追回「资产」，他循着最后一条线索找到了嫌疑人英民，却发现自己撞上的是一个冷静而残忍的连环杀手。时间在一分一秒地流逝，而警方的迟钝与体制的冷漠让营救变得越来越渺茫。',
    releaseDate: '2008-02-14',
    region: '韩国',
    tags: ['犯罪追逐', '罗泓轸', '真实灵感'],
  },
  {
    id: '15',
    title: '大叔',
    titleEn: 'The Man from Nowhere',
    year: 2010,
    director: '李政範',
    cast: ['元斌', '金赛纶', '坦娜永'],
    genres: ['剧情', '动作', '犯罪'],
    duration: 119,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=neo%20noir%20Korean%20action%20drama%20poster%2C%20lone%20figure%20in%20shadowed%20pawnshop%2C%20deep%20charcoal%20and%20amber%20highlights%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-15&orientation=portrait',
    summary: '一个沉默的当铺老板，为了邻家女孩重新走进黑暗的深渊。',
    synopsis: '车泰锡独来独往，经营着一间不起眼的当铺，唯一能靠近他内心的，是邻家小女孩素美。当素美与母亲被卷入器官贩卖的犯罪集团，这个沉默的男人卸下了往日的克制，用最直接的方式一路搏杀。影片以酣畅的动作与真挚的情感，写出一段近乎父女的羁绊。',
    releaseDate: '2010-08-04',
    region: '韩国',
    tags: ['动作情感', '李政範', '票房佳作'],
  },
  {
    id: '16',
    title: '汉江怪物',
    titleEn: 'The Host',
    year: 2006,
    director: '奉俊昊',
    cast: ['宋康昊', '边希峰', '朴海日', '裴斗娜'],
    genres: ['剧情', '科幻', '家庭'],
    duration: 120,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20creature%20drama%20poster%2C%20river%20bridge%20under%20gloomy%20grey%20sky%2C%20desaturated%20green%20and%20amber%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-16&orientation=portrait',
    summary: '一只怪物从汉江爬上河岸，一个普通家庭的营救之战就此展开。',
    synopsis: '汉江边，一个经营小卖部的平凡家庭。驻韩美军倾倒入江的化学物质催生出一只巨大的怪物，它在大白天冲上河岸，叼走了朴家最小的孙女。政府的无能与谎报让这个家庭被迫自救，一家人在混乱与悲伤中踏上了寻找孩子的路。奉俊昊把怪兽片拍成了一则关于普通人的社会寓言。',
    releaseDate: '2006-07-27',
    region: '韩国',
    tags: ['类型融合', '奉俊昊', '社会寓言'],
  },
  {
    id: '17',
    title: '雪国列车',
    titleEn: 'Snowpiercer',
    year: 2013,
    director: '奉俊昊',
    cast: ['克里斯·埃文斯', '宋康昊', '蒂尔达·斯文顿'],
    genres: ['剧情', '科幻', '动作'],
    duration: 126,
    rating: 7.9,
    cover: 'https://readdy.ai/api/search-image?query=dystopian%20Korean%20sci%20fi%20film%20poster%2C%20frozen%20snow%20covered%20train%20at%20night%2C%20icy%20blue%20and%20warm%20amber%20window%20light%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-17&orientation=portrait',
    summary: '冰封末世里，一列永不停歇的火车承载着完整的阶层秩序。',
    synopsis: '全球变暖实验失败后，地球进入冰河时代，幸存的人类蜗居在一列永不停歇的列车上。车厢从前到后划分出严密的阶层，末节车厢的乘客在压迫中酝酿反抗。一场从车尾向车头前进的起义，揭开了这列火车得以运转的真正秘密。奉俊昊用封闭空间完成了对秩序与革命的思考。',
    releaseDate: '2013-08-01',
    region: '韩国',
    tags: ['反乌托邦', '奉俊昊', '国际合拍'],
  },
  {
    id: '18',
    title: '釜山行',
    titleEn: 'Train to Busan',
    year: 2016,
    director: '延尚昊',
    cast: ['孔刘', '郑有美', '马东锡', '金秀安'],
    genres: ['剧情', '灾难', '惊悚'],
    duration: 118,
    rating: 8.5,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20zombie%20disaster%20film%20poster%2C%20high%20speed%20train%20interior%20with%20cold%20light%2C%20desaturated%20blue%20and%20red%20emergency%20accent%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-18&orientation=portrait',
    summary: '一趟开往釜山的高速列车，成为人性在末日中最后的试炼场。',
    synopsis: '自私的基金经理石宇带着女儿乘坐开往釜山的高铁，途中一场病毒席卷全国，乘客们在密闭的车厢里与感染者展开求生。面对不断逼近的威胁，冷漠的成年人逐渐被身边的陌生人唤醒。影片把灾难片的紧张节奏与父爱、牺牲的主题紧密缝合。',
    releaseDate: '2016-07-20',
    region: '韩国',
    tags: ['灾难类型', '延尚昊', '票房佳作'],
  },
  {
    id: '19',
    title: '新世界',
    titleEn: 'New World',
    year: 2013,
    director: '朴勋政',
    cast: ['李政宰', '崔岷植', '黄晸珉', '宋智孝'],
    genres: ['剧情', '犯罪', '悬疑'],
    duration: 134,
    rating: 8.3,
    cover: 'https://readdy.ai/api/search-image?query=stylish%20Korean%20gangster%20crime%20poster%2C%20neon%20lit%20cityscape%20at%20night%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-19&orientation=portrait',
    summary: '在权力真空中周旋的卧底，必须在忠诚与生存之间做出抉择。',
    synopsis: '警方安插在黑帮「金门」内部的卧底子成，已在组织高层潜伏多年。随着会长意外身亡，帮派内部为争夺继承权暗流涌动，警方也趁机布局换届。子成被迫在身份、兄弟情义与任务之间反复摇摆。影片以沉稳的讲述和出色的群像，写出了权力游戏里人的孤独。',
    releaseDate: '2013-02-21',
    region: '韩国',
    tags: ['黑帮叙事', '朴勋政', '群像'],
  },
  {
    id: '20',
    title: '局内人',
    titleEn: 'Inside Men',
    year: 2015,
    director: '禹民镐',
    cast: ['李炳宪', '曹承佑', '白润植'],
    genres: ['剧情', '犯罪', '政治'],
    duration: 130,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20political%20crime%20thriller%20poster%2C%20boardroom%20of%20power%20with%20harsh%20lighting%2C%20cold%20slate%20and%20amber%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-20&orientation=portrait',
    summary: '被权力抛弃的人联手反击，撕开政商媒体勾结的灰色网络。',
    synopsis: '黑帮打手安尚久在政治交易的博弈中被当作棋子抛弃，怀揣着复仇的执念重新入局。与此同时，一名检察官为了扳倒财阀与政客的同盟，将一个隐藏多年的资金秘密握在手中。两条复仇线在权力的缝隙里汇合，最终指向一张盘根错节的利益之网。',
    releaseDate: '2015-11-19',
    region: '韩国',
    tags: ['政治惊悚', '禹民镐', '票房佳作'],
  },
  {
    id: '21',
    title: '辩护人',
    titleEn: 'The Attorney',
    year: 2013,
    director: '杨宇硕',
    cast: ['宋康昊', '任时完', '郭度沅'],
    genres: ['剧情', '历史', '法庭'],
    duration: 127,
    rating: 8.6,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20legal%20drama%20film%20poster%2C%20wooden%20courtroom%20with%20warm%20window%20light%2C%20muted%20sepia%20and%20ivory%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-21&orientation=portrait',
    summary: '从逐利律师到为公义辩护，一个人在大时代里的转身。',
    synopsis: '只有高中学历的税务律师宋佑硕凭借过人的头脑白手起家，原本只想安稳赚钱。然而一次受托为受迫害的学生辩护，让他第一次直面自己所处的时代。他开始在法庭上与权力正面周旋，也逐渐明白所谓「安稳」从来不是理所当然。影片取材自真实人物，克制而有力。',
    releaseDate: '2013-12-18',
    region: '韩国',
    tags: ['真实改编', '杨宇硕', '时代记忆'],
  },
  {
    id: '22',
    title: '熔炉',
    titleEn: 'Silenced',
    year: 2011,
    director: '黄东赫',
    cast: ['孔刘', '郑有美', '金志映'],
    genres: ['剧情', '社会', '犯罪'],
    duration: 125,
    rating: 8.4,
    cover: 'https://readdy.ai/api/search-image?query=somber%20Korean%20social%20drama%20poster%2C%20foggy%20small%20town%20school%20gate%2C%20desaturated%20grey%20and%20amber%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-22&orientation=portrait',
    summary: '一位美术老师走进聋哑学校，揭开被沉默掩盖的黑暗。',
    synopsis: '为谋生计，仁浩从首尔来到雾津的一所聋哑学校任教，却发现校园里弥漫着不寻常的压抑。随着与学生们的接触加深，他逐渐拼凑出被刻意隐藏的真相。面对利益与权力的重重阻挠，他选择站到孩子们身边。影片上映后推动了相关的立法讨论，成为社会电影的重要案例。',
    releaseDate: '2011-09-22',
    region: '韩国',
    tags: ['社会议题', '黄东赫', '真实改编'],
  },
  {
    id: '23',
    title: '素媛',
    titleEn: 'Hope',
    year: 2013,
    director: '李濬益',
    cast: ['薛景求', '严志媛', '李来'],
    genres: ['剧情', '家庭', '社会'],
    duration: 122,
    rating: 8.7,
    cover: 'https://readdy.ai/api/search-image?query=warm%20Korean%20family%20drama%20film%20poster%2C%20hopeful%20morning%20light%20on%20a%20window%2C%20soft%20cream%20and%20coral%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-23&orientation=portrait',
    summary: '一场创伤之后，一个家庭在爱与陪伴中艰难地重新站起。',
    synopsis: '小女孩素媛在一次不幸的遭遇中受到重创，原本普通的家庭被彻底打乱。父母在自责与痛苦中，努力学着如何陪伴女儿走出阴影。邻居、老师与陌生人的善意，一点一点地让这个家重新有了光。影片用极大的温柔处理沉重题材，让「希望」二字有了具体的重量。',
    releaseDate: '2013-10-02',
    region: '韩国',
    tags: ['家庭治愈', '李濬益', '真实改编'],
  },
  {
    id: '24',
    title: '思悼',
    titleEn: 'The Throne',
    year: 2015,
    director: '李濬益',
    cast: ['宋康昊', '刘亚仁', '文瑾莹'],
    genres: ['剧情', '历史', '宫廷'],
    duration: 125,
    rating: 8.3,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20period%20court%20drama%20poster%2C%20royal%20palace%20hall%20with%20candlelight%2C%20deep%20crimson%20and%20gold%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=kfilm-poster-24&orientation=portrait',
    summary: '朝鲜王朝最悲剧的父子，在礼法与真情之间走向决裂。',
    synopsis: '英祖大王与世子李愃，是一对彼此深爱又互相折磨的父子。父亲以严苛的期待束缚着儿子，而儿子在压抑与孤独中逐渐迷失。一场注定无法和解的对峙，最终把一个王朝的隐痛推向极致。影片在宫廷的礼制框架下，写尽了亲情中最难言说的部分。',
    releaseDate: '2015-09-16',
    region: '韩国',
    tags: ['历史宫廷', '李濬益', '父子关系'],
  },
  {
    id: '25',
    title: '东柱',
    titleEn: 'Dongju',
    year: 2016,
    director: '李濬益',
    cast: ['姜河那', '朴正民'],
    genres: ['剧情', '传记', '历史'],
    duration: 110,
    rating: 7.9,
    cover: 'https://readdy.ai/api/search-image?query=black%20and%20white%20Korean%20poet%20biopic%20poster%2C%20solitary%20figure%20in%20snow%2C%20monochrome%20charcoal%20tones%20with%20faint%20amber%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-25&orientation=portrait',
    summary: '黑暗年代里，一位年轻诗人的沉默与坚持。',
    synopsis: '影片讲述朝鲜时代末期诗人尹东柱短暂而明亮的生命。他在动荡的岁月里写诗、求学、思考，与挚友宋梦奎走上截然不同却又彼此映照的道路。白色的雪、黑色的字、克制的镜头，构成对一段沉重历史的深情回望。',
    releaseDate: '2016-02-17',
    region: '韩国',
    tags: ['诗人传记', '李濬益', '黑白影像'],
  },
  {
    id: '26',
    title: '绿洲',
    titleEn: 'Oasis',
    year: 2002,
    director: '李沧东',
    cast: ['薛景求', '文素利'],
    genres: ['剧情', '爱情', '文艺'],
    duration: 132,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=tender%20Korean%20romantic%20drama%20poster%2C%20sunlight%20through%20thin%20curtains%20in%20a%20room%2C%20warm%20ivory%20and%20soft%20amber%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-26&orientation=portrait',
    summary: '两个被社会忽视的边缘人，在彼此的注视中找到了一片绿洲。',
    synopsis: '刚出狱的洪宗道替肇事逃逸的哥哥顶罪，回到社会后处处碰壁。他找到死者家属韩恭珠的家，遇见患有脑瘫、被家人冷落的恭珠。两个被世界遗忘的人，在笨拙而真诚的靠近里，拥有了一段不被理解却无比珍贵的感情。李沧东以温柔的目光重新定义了「正常」。',
    releaseDate: '2002-08-28',
    region: '韩国',
    tags: ['边缘爱情', '李沧东', '现实主义'],
  },
  {
    id: '27',
    title: '蝙蝠',
    titleEn: 'Thirst',
    year: 2009,
    director: '朴赞郁',
    cast: ['宋康昊', '金玉彬', '申河均'],
    genres: ['剧情', '恐怖', '爱情'],
    duration: 133,
    rating: 7.7,
    cover: 'https://readdy.ai/api/search-image?query=gothic%20Korean%20vampire%20drama%20poster%2C%20dark%20bedroom%20with%20candlelight%20and%20shadow%2C%20deep%20wine%20and%20cream%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-27&orientation=portrait',
    summary: '一场实验意外让神父成为吸血鬼，也唤醒了他压抑已久的欲望。',
    synopsis: '虔诚的神父相贤为疫苗实验献身，意外感染后却以吸血鬼的形态「复活」。他开始渴望血液，也在与友人妻子的相遇中被情欲彻底卷入。圣洁与罪恶、信仰与本能在他体内相互撕扯。朴赞郁将伦理、宗教与类型元素搅拌成一杯浓烈而危险的酒。',
    releaseDate: '2009-04-30',
    region: '韩国',
    tags: ['欲望与信仰', '朴赞郁', '类型实验'],
  },
  {
    id: '28',
    title: '呼吸',
    titleEn: 'Breathless',
    year: 2009,
    director: '梁益准',
    cast: ['梁益准', '金花雨'],
    genres: ['剧情', '独立', '社会'],
    duration: 130,
    rating: 7.6,
    cover: 'https://readdy.ai/api/search-image?query=raw%20Korean%20indie%20drama%20poster%2C%20grimy%20alley%20at%20dusk%2C%20desaturated%20olive%20and%20grey%20tones%2C%20gritty%20texture%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-28&orientation=portrait',
    summary: '一个暴力成性的男人，在怒火中烧的生活里遇见另一种可能。',
    synopsis: '街头混混相勋用拳头和脏话对抗整个世界，与他相依为命的只有妹妹。一次冲突中，他遇见了背着沉重家庭负担的女高中生妍熙。两个都被生活磨得生疼的人，在互相伤害与靠近之间，试图寻找一丝喘息的空间。影片以生猛的写实风格，留下独立电影的一道印记。',
    releaseDate: '2009-02-20',
    region: '韩国',
    tags: ['独立电影', '梁益准', '社会写实'],
  },
  {
    id: '29',
    title: '国家破产之日',
    titleEn: 'Default',
    year: 2018,
    director: '崔国熙',
    cast: ['金惠秀', '刘亚仁', '许峻豪'],
    genres: ['剧情', '经济', '历史'],
    duration: 114,
    rating: 7.8,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20financial%20crisis%20drama%20poster%2C%20trading%20floor%20screens%20with%20red%20numbers%2C%20cold%20slate%20and%20amber%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-29&orientation=portrait',
    summary: '危机来临前的一周，不同立场的人各自押上自己的赌注。',
    synopsis: '1997 年，韩国濒临国家破产的边缘。货币投机者尹正学在风暴中寻找机会，银行分析师韩诗贤拼命想向决策层发出警告，而普通家庭则在无声的破产中艰难挣扎。影片以多线叙事还原那场席卷全国的经济危机，追问责任与选择究竟落在谁的身上。',
    releaseDate: '2018-11-28',
    region: '韩国',
    tags: ['经济题材', '崔国熙', '多线叙事'],
  },
  {
    id: '30',
    title: '分手的决心',
    titleEn: 'Decision to Leave',
    year: 2022,
    director: '朴赞郁',
    cast: ['汤唯', '朴海日', '李贞贤'],
    genres: ['剧情', '爱情', '悬疑'],
    duration: 138,
    rating: 8.1,
    cover: 'https://readdy.ai/api/search-image?query=moody%20romantic%20Korean%20police%20drama%20poster%2C%20misty%20seaside%20cliff%20at%20dusk%2C%20deep%20teal%20and%20warm%20amber%20tones%2C%20minimalist%2C%20no%20text&width=600&height=900&seq=kfilm-poster-30&orientation=portrait',
    summary: '一位刑警在调查命案时，对嫌疑人心生出无法承认的情感。',
    synopsis: '刑警海俊习惯在案件现场捕捉细节，也习惯用睡眠不足惩罚自己的失眠。当他接手一桩山中坠亡案，遇见了死者的异国妻子瑞莱，调查的边界开始变得模糊。理智与心动互相拉扯，最终两人都做出了各自的决定。朴赞郁用精密的镜头语言，把一部刑侦片拍成了一首关于克制之爱的小诗。',
    releaseDate: '2022-06-29',
    region: '韩国',
    tags: ['导演获奖', '朴赞郁', '当代佳作'],
  },
];